import React from "react";

import AppRouter from "./AppRouter";

import {
  DevicePreviewContext,
  previewDevices,
} from "./contexts/device-preview-context";

class AppWithContext extends React.Component {
  constructor(props) {
    super(props);

    this.toggleDevicePreview = (deviceType) => {
      this.setState(() => ({
        previewDevice: previewDevices[deviceType],
      }));
    };

    // State also contains the updater function so it will
    // be passed down into the context provider
    this.state = {
      previewDevice: previewDevices.phone,
      toggleDevicePreview: this.toggleDevicePreview,
    };
  }

  render() {
    // The entire state is passed to the provider
    return (
      <DevicePreviewContext.Provider value={this.state}>
        <AppRouter />
      </DevicePreviewContext.Provider>
    );
  }
}

export default AppWithContext;
